module.exports = __webpack_public_path__ + "img/03-thumb.5719e1f4.jpg";